module.exports = __webpack_public_path__ + "static/media/cortena.6d02f19f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/cortena.webp
// module id = 298
// module chunks = 0